/*
 * @Author: zjw
 * @Date: 2021-06-10 15:49:21
 * @LastEditTime: 2022-11-16 16:25:38
 * @FilePath: \web-app\src\network\other\feedBack.js
 * @Environment: Vue + Element
 * @Description: 意见反馈
 */
import {
    request
} from '../request.js';

// 列表
export function feedBackList(data) {
    return request({
        url: '/web/back/feedback/page',
        method: 'post',
        data
    })
}

// 删除
export function delFeedBack(data) {
    return request({
        url: '/web/back/feedback/delete' + "?id=" + data,
        method: 'delete',
    })
}

// 批量删除
export function allDelFeedBack(data) {
    return request({
        url: '/web/back/feedback/batch/delete',
        method: 'delete',
        data
    })
}